/**
 * Thrown when a nested feature is encountered (features cannot contain other features as geometry)
 */
export class NestedFeatureError extends Error {
  constructor() {
    super(
      "Nested features are not supported - geometry must be a geometry type, not a feature",
    );
    this.name = "NestedFeatureError";
  }
}

/**
 * Thrown when a nested feature is encountered (features cannot contain other features as geometry)
 */
export class UnsupportedBlockTypeError extends Error {
  constructor(blockType: string) {
    super(
      `Cannot transform ${blockType} block type into a GeoJSON representation`,
    );
    this.name = "UnsupportedBlockTypeError";
  }
}
